import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import recipe from "../../Assets/Projects/recipe.jpg";
import blo from "../../Assets/Projects/blo.jpeg";
import shortner from "../../Assets/Projects/shortner.png"
import blog from "../../Assets/Projects/blog.png"

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blog}
              isBlog={false}
              title="Blogging Application"
              description="Built with TypeScript, Node.js, Next.js, Tailwind, Redis, and MongoDB, this blogging platform features an integrated rate limiter for security. Authenticated users can create, upload images, and manage blogs and comments. Enhancing user experience, it includes a Search Bar, pagination, and server-side filter facilities."
              ghLink="https://github.com/DikshakAdhikari/Blogging-Application"
       
              
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shortner}
              isBlog={false}
              title="URL Shortner"
              description="Simplify URL sharing with this application powered by TypeScript, Tailwind, Next.js, Node.js, Express, MongoDB, and Redis. Authenticated users can input a website URL and receive a significantly
              shortened version. Authorization is role-based, assigned during user creation."
              ghLink="https://github.com/DikshakAdhikari/Url-Shortner"
            
              
            />
          </Col>

        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={blo}
              isBlog={false}
              title="Course-Selling-App"
              description="A course marketing application is built with ReactJS, MUI, Recoil, Node.js, and MongoDB. It features separate admin and user interfaces. Admins, after authentication, can easily manage courses. Users can create accounts, log in, and smoothly purchase courses for a seamless experience."
              ghLink="https://github.com/DikshakAdhikari/sellingCourse"
              demoLink="https://dikshak-admin-course.vercel.app/"
              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={recipe}
              isBlog={false}
              title="Recipe-App"
              description="This web platform, employing HTML, CSS, ReactJS, NodeJS, and MongoDB, enables user authen-
              tication and validation, along with CRUD operations. Users can register, log in/out, and submit
              recipes in their profiles, including an image, ingredients, cooking time, and description."
              ghLink="https://github.com/DikshakAdhikari/RecipeApp"
              demoLink="https://dikshakrecipe.vercel.app/"
            />
          </Col>



         
         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
